export const color: { [key: string]: boolean } = {
  bC: true,
  bgC: true,
  c: true,
};
export const size: { [key: string]: boolean } = {
  h: true,
  maxH: true,
  maxW: true,
  minH: true,
  minW: true,
  w: true,
};
export const space: { [key: string]: boolean } = {
  g: true,
  gX: true,
  gY: true,
  m: true,
  mB: true,
  mL: true,
  mR: true,
  mT: true,
  mX: true,
  mY: true,
  p: true,
  pB: true,
  pL: true,
  pR: true,
  pT: true,
  pX: true,
  pY: true,
  sX: true,
  sY: true,
};
